import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDrop } from 'react-dnd';
import ShortUniqueId from 'short-unique-id';
import { NotificationDialog } from '../../CommonFunctions/DialogComponents';
interface EvatuationRightOperandDropZoneProps {
  indicator?: 'First' | 'Second';
  leftOperandType: string;
  onDrop: (index: 0 | 1, value: string, valueType: string, valueInfo: any) => void;
  disabled?: boolean;
}
function EvatuationRightOperandDropZone({
  leftOperandType,
  indicator,
  onDrop,
  disabled,
}: EvatuationRightOperandDropZoneProps) {
  const [alert, setAlert] = useState<{
    severity: 'warning' | 'error' | 'info' | 'success';
    message: string;
  } | null>(null);
  const [showBorder, setShowBorder] = useState(false);

  const [{ isOver }, drop] = useDrop({
    accept: ['card', 'step', 'calculation', 'calculationSelected'],
    hover: (item: any, monitor) => {
      if (monitor.isOver({ shallow: true }) && !showBorder) {
        setShowBorder(true);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver({ shallow: true }),
      canDrop: monitor.canDrop(),
    }),
    drop: (item: any) => {
      setShowBorder(false);
      if (disabled) {
        setAlert({
          severity: 'warning',
          message:
            'This calculation is being used in another flow. Please remove the dependency before deleting.',
        });
        return;
      }
      if (['calculation', 'step'].includes(item.type)) {
        setAlert({
          severity: 'warning',
          message: 'Using another calculated field as a source feature is coming in future release',
        });
        return;
      }

      const uid = new ShortUniqueId({ length: 4 })();
      if (!uid) return;
      if (item.fieldData.dataType !== leftOperandType) {
        setAlert({
          severity: 'warning',
          message: 'Data type of right operand should be same as left operand',
        });
        return;
      }
      const updateIndex = indicator === 'Second' ? 1 : 0;
      onDrop(
        updateIndex,
        item.type === 'card' ? uid : item.uid,
        item.type === 'card' ? 'field' : 'flow',
        item.fieldData,
      );
    },
  });

  useEffect(() => {
    if (!isOver) {
      setShowBorder(false);
    }
  }, [isOver]);

  return (
    <Box
      ref={drop}
      onDragEnter={(e) => e.preventDefault()}
      sx={{
        fontSize: '8px',
        color: '#999999',
        padding: '10px',
        textAlign: 'center',
        border: '1px dashed #d3d3d3',
        borderRadius: '5px',
        width: '100%',
        height: '3rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      className={`dropzone ${showBorder ? 'dropzone-highlighted' : ''}`}
    >
      {alert && (
        <NotificationDialog
          severity={alert.severity}
          openAlert={!!alert}
          onCloseAlert={() => setAlert(null)}
          testMessage={alert.message}
        />
      )}
      Drop the right operand here {indicator && `(${indicator})`}
    </Box>
  );
}

export default EvatuationRightOperandDropZone;
